import React, { useContext } from 'react'
import {
  FooterSection,
  LinksDiv,
  RedirectLink,
  CopyrightInfo,
  SocialIcons,
} from './styles'
import { AccountContext } from '../../providers/accountProvider'

function Footer() {
  const { user } = useContext(AccountContext)
  const contactUsPage =
    user.location === 'US'
      ? 'https://pocketfm.com/us/contact-us'
      : 'https://www.pocketnovel.com/contact-us'

  return (
    <FooterSection>
      <LinksDiv>
        <RedirectLink
          href="https://www.pocketfm.com/about-us"
          target="_blank"
          rel="noopener"
        >
          About US
        </RedirectLink>
        <RedirectLink
          href={contactUsPage}
          target="_blank"
          rel="noopener"
        >
          Contact US
        </RedirectLink>
        <RedirectLink
          href="https://www.pocketfm.com/privacy-policy"
          target="_blank"
          rel="noopener"
        >
          Privacy Policy
        </RedirectLink>
        <RedirectLink
          href="https://www.pocketfm.com/copyright"
          target="_blank"
          rel="noopener"
        >
          Copyright
        </RedirectLink>
        <RedirectLink
          href="https://www.pocketfm.com/terms-and-conditions"
          target="_blank"
          rel="noopener"
        >
          Terms and Conditions
        </RedirectLink>
        <RedirectLink href="/content-and-community-guidelines">
          Content & Community Guidelines
        </RedirectLink>
      </LinksDiv>
      <SocialIcons>
        <a
          rel="noopener"
          target="blank"
          href="https://www.facebook.com/pocketfmindia/"
        >
          <img src="/images/facebook-grey-dark.svg" />{' '}
        </a>
        <a
          rel="noopener"
          target="blank"
          href="https://www.instagram.com/pocketfm_india"
        >
          <img src="/images/instagram-grey-dark.svg" />{' '}
        </a>
        <a
          rel="noopener"
          target="blank"
          href="https://www.youtube.com/c/PocketFM"
        >
          <img src="/images/youtube-grey-dark.svg" />{' '}
        </a>
        <a
          rel="noopener"
          target="blank"
          href="https://twitter.com/PocketFM_App"
        >
          <img src="/images/twitter-grey-dark.svg" />{' '}
        </a>
      </SocialIcons>
      <CopyrightInfo>
        <p>Pocket FM Private Limited © 2018 - {new Date().getFullYear()}</p>
      </CopyrightInfo>
    </FooterSection>
  )
}

export default Footer
